import { render } from "./SServices.vue?vue&type=template&id=5e93eb4c"
import script from "./SServices.vue?vue&type=script&lang=js"
export * from "./SServices.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\ssradius\\frontend_tr\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__